module.exports = __webpack_public_path__ + "img/EP18Menu2.b139c055.png";